module.exports = __webpack_public_path__ + "img/energy_fac_blue.280abf79.png";